import { createTheme } from '@mui/material/styles';

// Dark by default (carried over from Rev 1); light theme follows later.
export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#f5b942' },
    background: { default: '#0b0f17', paper: '#131a26' },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  },
});
